
import { defineComponent, onMounted, onUnmounted, ref,nextTick } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { getIllustrationsPath } from "@/core/helpers/assets";
import Licitaciones from "@/components/licitaciones/Licitaciones.vue";
import Noticias from "@/components/noticias/Noticias.vue";

export default defineComponent({
  name: "auth",
  components: {
    Licitaciones,
    Noticias
  },
  setup() {
    const store = useStore();
    const mostrar = ref(true)

    onMounted(() => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
    });

    onUnmounted(() => {
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
    });

    const mostrarLicitaciones =async (valor) =>{
       mostrar.value = false
        await nextTick()
         mostrar.value = valor 
    }

    return {
      getIllustrationsPath,
      mostrarLicitaciones,
      mostrar
    };
  },
});
